module.exports = __webpack_public_path__ + "static/media/sad.e9d73307.png";